import { tutorsConstants } from './constants';

var viewActions = require ('../../store/view.actions');
var tutorsService = require ('./api');

export const tutorsActions = {
  getTutorCourses 
};  


function getTutorCourses( token, calendarID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getTutorCourses', true)) ;
       
          tutorsService.getTutorCourses( token, calendarID )
          .then( json => {
              dispatch( { 
                        type: tutorsConstants.SHOW_TUTOR_COURSES,
                        tutorCourses: json
                      }) ;
              dispatch(viewActions.isLoadingModule('getTutorCourses', false) )
          } )
          
  }
}
